const ERRORS_CONFIG = {
  default: {
    primary: 'We’re sorry, something went wrong.',
    secondary: 'Please go back and try your action again.',
    buttonText: 'Go Back',
    analytics: 'general error',
    action: 'goBack',
  },
  ERROR_FILESIZE: {
    primary: 'Your image is too large.',
    secondary: 'Please select an image less than 20mb.',
    buttonText: 'Select New Photo',
    analytics: 'filesize of uploaded image exceeds 20MB',
    action: 'selectNewPhoto',
  },
  ERROR_FILETYPE: {
    primary: 'Image type unsupported.',
    secondary: 'Please select a .jpg or .png image.',
    buttonText: 'Select New Photo',
    analytics: 'Uploaded image has the wrong file format.',
    action: 'selectNewPhoto',
  },
  ERROR_NO_FACE: {
    primary: 'No face detected.',
    secondary: 'Please try a different image to proceed.',
    buttonText: 'Select New Photo',
    analytics: 'no face is detected for the uploaded image by makeup library facetracker',
    action: 'selectNewPhoto',
  },
  ERROR_SMALL_IMG: {
    primary: 'Your image is too small.',
    secondary: 'Please select an image with a height<br> and width of at least 300px.',
    buttonText: 'Select New Photo',
    analytics: 'dimensions of uploaded image is too small (height or width is less than 300)',
    action: 'selectNewPhoto',
  },
  ERROR_WEBCAM: {
    primary: 'We’re having trouble<br> accessing your webcam.',
    secondary: 'Please check it’s connected and try again.',
    buttonText: 'Open Live Camera',
    analytics: 'webcam initialization has failed',
    action: 'openLiveCamera',
    alert: 'You must provide Macy’s access to your camera to use the Try On experience with Live Camera.',
  },
};

function formatError(error) {
  const currentErrorKey = Object.keys(ERRORS_CONFIG).find((key) => {
    const regex = new RegExp(key);
    return regex.test(error);
  });

  return ERRORS_CONFIG[currentErrorKey] || ERRORS_CONFIG.default;
}

export {
  ERRORS_CONFIG,
  formatError,
};
